import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { IRFQViewModel, IRfqQuoteSupplierQuoteViewModel, ITerritoryClassificationModel, DownloadAllFilesViewModel
} from '../../../core/models/rfqModel';
import { IPartLibraryModel } from '../../../core/models/partModel';
import { appConstants } from '../../../core/config/constant';
import { MasterService } from '../../../core/services/master/master.service';
import { ProfileService } from '../../../core/services/profile/profile.service';
import { IContactViewModel } from '../../../core/models/accountModel';
import { RfqService } from '../../../core/services/rfq/rfq.service';
import { SupplierService } from '../../../core/services/supplier/supplier.service';
import { IManufacturerDashboardViewModel } from '../../../core/models/supplierProfileModel';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-supplier-rfq-detail-rightpanel',
  templateUrl: './rfq-detail-rightpanel.component.html',
  styleUrls: ['./rfq-detail-rightpanel.component.scss']
})
export class SupplierRfqDetailRightPanelComponent implements OnInit, OnDestroy {
  
  iProfileSetModel: IManufacturerDashboardViewModel;
  @Output() parentEmitter = new EventEmitter<any>();

  actionForGrowthPackage: string;
  @Input()
  selectedRFQ:any={};
  private isRFQForm2Enabled=false;
  
  isProfessionalPackage: boolean;
  isLoader: boolean;
  isNDAaccepted: boolean;
  iRfqQuoteSupplierQuoteViewModel: IRfqQuoteSupplierQuoteViewModel;
  Downloadallfiles: DownloadAllFilesViewModel;
  temp: string[];
  isSupplierDetailPage: boolean = false;
  irfqViewModel: IRFQViewModel;
  ITerritoryClassificationModelColl: ITerritoryClassificationModel[];
  importanceOrder: string;
  preferredMfgLocText: string;
  whoPaysForShippingText: string;
  shippingAddress: any = {
    companyName: '',
    streetAddress: '',
    deptAddress: '',
    city: '',
    state: '',
    postalCode: '',
    country: ''
  };
  iReviewPartsViewModelColl: IPartLibraryModel[];
  prefNDATypeText: string;
  iContactViewModel2: IContactViewModel;
  isStandardNda: boolean = true;
  customNDAFile: string;
  shippingReviewData: any;
  isFileDownloaded: number;
  isFileDownloaded1: number;
  isFileDownloaded2: number;
  
  preferredCommunicationArray: string[] = [];
  accountType: string;
  showDrawer:boolean = false;
  // Variable declaration End

  constructor(private _rfqService: RfqService, private _masterService: MasterService, private _SupplierService: SupplierService, private _profileService: ProfileService, private router: Router, private _toastr: ToastrService) {
    this.isLoader = true;
    this.temp = [];
    this.isNDAaccepted = false;
    this.Downloadallfiles = {
      filename: [],
      rfQ_Id: 0,
      part_id: 0
    }
        this.isLoader = true;
  }

  ngOnInit() {
    this.isProfessionalPackage = AppStorageUtil.getItem("isProfessionalPackage")

    this._profileService.getConfigCatData().subscribe(rfqForm2Enabled => {
      this.isRFQForm2Enabled=rfqForm2Enabled;
    });
    this.accountType = AppStorageUtil.getItem('AccountType');
    let url = this.router.url;
    this.isSupplierDetailPage = url.includes('/supplier/supplierRfqDetails');
    const elmnt = document.getElementById("rfqDrawer");
    elmnt.scrollIntoView({
      behavior: 'auto',
      block: 'start',
      inline: 'nearest'
    });
    this.getRfqDetails();
    this.getPartsList();
   

    this.preferredCommunicationArray[117] = 'Call';
    this.preferredCommunicationArray[118] = 'Message';
    this.preferredCommunicationArray[119] = 'Email';
    this.preferredCommunicationArray[120] = 'Call or Email';
    this.iProfileSetModel = {
      isCompanyDescription: null,
      isCompanyLogo: null,
      isCompanyBanner: null,
      isVisitMyRFQ: null,
      isCompanyCapabilities: null,
      contactId: this.loggedId,
      isPublishProfile: null,
      isCompanyAddress: null
    };
    this.isFileDownloaded = 0;
    this.isFileDownloaded1 = 0;
    this.isFileDownloaded2 = 0;
    
    // this.fillDropDown();
    this.getRfqDetails();
    this.getBuyerLocation();
    this.getPartsList();
    if (AppStorageUtil.getItem('isMyRfqPage') !== undefined && AppStorageUtil.getItem('isMyRfqPage') !== null) {
      this.setProfileStatus();
    }
  }

  clickOutside(){
    this.closePartDrawer();
  }

  setProfileStatus() {
    AppStorageUtil.removeItem('isMyRfqPage');
    this.iProfileSetModel.isVisitMyRFQ = true;
    this._SupplierService.setProfileDashBoard(this.iProfileSetModel).subscribe(
      result => {
        if (result) {
          console.log(result);
        }
      }
    );
  }

  closePartDrawer() {
    this.parentEmitter.emit({showSidePanel:false});
  }
  ngOnDestroy() {
    this.closePartDrawer();
  }

  // APi function calls
  getRfqDetails() {
    this.isLoader=true;
    let supplierContactId = 0;
    supplierContactId = this.loggedId;
    this._rfqService.getRFQExtraDetails(this.selectedRFQ.rfqId, supplierContactId, '').subscribe(
      result => {
        this.isLoader=false;
        if (result.result === true) {
          result.preferredMfgLocationIds = this.locationIdsIntToString(result.preferredMfgLocationIds);
          this.irfqViewModel = result;
          this.showDrawer = true;
          this.actionForGrowthPackage  =result.actionForGrowthPackage;
          this.irfqViewModel.awardDate = moment.utc(this.irfqViewModel.awardDate).toDate();
          this.irfqViewModel.quotesNeededBy = moment.utc(this.irfqViewModel.quotesNeededBy).toDate();
          if (!this.irfqViewModel.payment_term_id || this.irfqViewModel.payment_term_id.toString() === '') {
            this.irfqViewModel.payment_term_id = 2;
          }

          this.formatDataRFQData();
          this.GetSupplierRFQQuoteDetails();
        } else if(result.errorMessage === 'InValidBuyer.') {
          // if(this._rfqService.isInValidBuyerWarningShown === false) {
            this._toastr.warning('Please login with valid buyer', 'Warning!');
            this.router.navigate(['dashboard/buyer/default']);
          // } 
        } 
      },
      error => {
        this.isLoader=false;
        this._rfqService.handleError(error);
      },
      () => { }
    );
  }

  getQuantityByLeval(partid, leval) {
    const part = this.iReviewPartsViewModelColl.find(m => m.partId === partid);
    const quantity = part.rfqPartQuantityList.find(m => m.quantityLevel === leval);
    if (quantity !== undefined) {
      return quantity.partQty;
    }

  }
  locationIdsIntToString(localColl) {
    const obj = [];
    (localColl).forEach(element => {
      if (!!element && (element !== 0)) {
        obj.push('' + element);
      }
    });
    return obj;
  }

  // APi function calls Ends

  // Extra Utility Function

  formatDataRFQData() {
    this.importanceOrder = this.getSortedOrderOfImportance();
    this.preferredMfgLocText = this.getPreferredMfgLoc();

    this.whoPaysForShippingText = this.keyByValue(this.irfqViewModel.whoPaysForShipping, appConstants.paysForShippingCode);
    this.prefNDATypeText = this.keyByValue(this.irfqViewModel.ndaTypekey, appConstants.NDAType);
    // this.getPartsList();
    this.getAddress();
    this.getSavedCustomeNdaFiles();
  }

  getSortedOrderOfImportance() {
    if (this.irfqViewModel) {
      const obj = {
        Speed: this.irfqViewModel.importanceSpeed,
        Price: this.irfqViewModel.importancePrice,
        Quality: this.irfqViewModel.importanceQuality,
      };
      return (Object.keys(obj).sort(function (a, b) { return obj[a] - obj[b]; })).join(', ');
    }
  }

  getPreferredMfgLoc() {
    if (this.irfqViewModel) {
      const obj = [];
      (this.irfqViewModel.preferredMfgLocationIds).forEach(element => {
        if (!!element && (element !== '') && (element !== '0')) {
          const locationNumber = Number(element);
          if (this.ITerritoryClassificationModelColl !== undefined) {
            const data = this.ITerritoryClassificationModelColl.find(m => m.territoryClassificationId === locationNumber)
              .territoryClassificationName;
            obj.push(data);
          }

        }
      });
      return obj.join(', ');
    }
  }

  getBuyerLocation() {
    const count = this._rfqService.get('ITerritoryClassificationModelColl');
    if (count !== undefined) {
      this.ITerritoryClassificationModelColl = this._rfqService.get('ITerritoryClassificationModelColl');
      this.preferredMfgLocText = this.getPreferredMfgLoc();
    } else {
      this._masterService.GetTerritoryClassification().subscribe(
        (data2: ITerritoryClassificationModel[]) => {
          this._rfqService.set(data2, 'ITerritoryClassificationModelColl');
          this.getBuyerLocation();
          this.preferredMfgLocText = this.getPreferredMfgLoc();
        },
        error => () => {
          this._rfqService.handleError(error);
        },
        () => { }
      );
    }
  }

  keyByValue(value, arr) {
    const kArray = Object.keys(arr);        // Creating array of keys
    const vArray = Object.values(arr);      // Creating array of values
    const vIndex = vArray.indexOf(value);         // Finding value index
    return kArray[vIndex];                      // Returning key by value index
  }

  getPartsList() {
    this._rfqService.getReviewRfqParts(this.selectedRFQ.rfqId, this.loggedId, false).subscribe(
      result => {
        if(result){
          this.iReviewPartsViewModelColl = result;
          this.iReviewPartsViewModelColl.forEach(part => {
            part.deliveryDate = moment.utc(part.deliveryDate).toDate();
            part.partDescription = part.partDescription + '<br>' + part.customPartDescription;
          });
          this.isLoader = false;
        }
      },
      error => {
        this._rfqService.handleError(error);
      },
      () => { }
    );
  }

  getAddress() {
    this._profileService.getAddress(this.irfqViewModel.contactId).subscribe(
      (data: IContactViewModel) => {
        this.iContactViewModel2 = data;
        if (this.iContactViewModel2 && this.iContactViewModel2.address &&
          this.iContactViewModel2.address.companyShippingSiteViewModelList) {
          this.shippingReviewData = this.iContactViewModel2.address.companyShippingSiteViewModelList;
          for (const entry of this.shippingReviewData) {
            if (entry.siteId === this.irfqViewModel.shipTo) {
              this.shippingAddress.siteLabel = entry.siteLabel;
              this.shippingAddress.companyName = entry.companyName;
              this.shippingAddress.streetAddress = entry.addresses.streetAddress;
              this.shippingAddress.deptAddress = entry.addresses.deptAddress;
              this.shippingAddress.city = entry.addresses.city;
              this.shippingAddress.postalCode = entry.addresses.postalCode;
              this.shippingAddress.state = entry.addresses.state;
              this.shippingAddress.country = entry.addresses.country;
            }
          }
        }
      },
      error => () => {
        this._rfqService.handleError(error);
      }
    );
  }
  get loggedId() {
    return parseInt(AppStorageUtil.getItem('LoggedId'));
  }
  get loggedCompanyId() {
    return parseInt(AppStorageUtil.getItem('loggedCompanyId'));
  }


  GetSupplierRFQQuoteDetails() {
    this.isNDAaccepted = true;
    this._SupplierService.GetSupplierRFQQuoteDetails(this.selectedRFQ.rfqId, this.loggedId, false).subscribe(
      result => {
        this.iRfqQuoteSupplierQuoteViewModel = result;
        if (this.isPremium()) {
          if (this.iRfqQuoteSupplierQuoteViewModel.ndaStatus === 'ACCEPTED') {
            this.isNDAaccepted = true;
          }
          if (this.iRfqQuoteSupplierQuoteViewModel.ndaStatus === null) {
            this.isNDAaccepted = false;
          }
          if (this.iRfqQuoteSupplierQuoteViewModel.ndaStatus === 'Viewed') {
            this.isNDAaccepted = false;
          }
          if (this.iRfqQuoteSupplierQuoteViewModel.ndaStatus === 'DECLINED') {
            this.isNDAaccepted = false;
          }
          if (this.iRfqQuoteSupplierQuoteViewModel.ndaStatus === '') {
            this.isNDAaccepted = false;
          }
        }
      });
  }
  downloadS3File(fileName: string, isDownload: boolean,rfqId: number) {
    ++this.isFileDownloaded;
    this._rfqService.getS3FileDownload(fileName).subscribe(response => {
      --this.isFileDownloaded;
      if (response.result && response.result.result && response.result.result === true) {
        const resData = response.result;
        const filelink = resData.fileName;
        const fileData = {
          rfQ_Id: rfqId,
          filename: fileName
        };
        this.logRFQFileClick(fileData,"downloadSingleFile");
        if (filelink) {
          if (/(iP)/g.test(navigator.userAgent)) {
            window.open(filelink, '_blank');
          }
          // If in Chrome or Safari - download via virtual link click
          const link = document.createElement('a');
          link.href = filelink;
          link.setAttribute('target', '_blank');

          if (link.download !== undefined && isDownload) {
            // Set HTML5 download attribute. This will prevent file from opening if supported.
            fileName = filelink.substring(filelink.lastIndexOf('/') + 1, filelink.length);
            link.download = fileName;
          }
          // Dispatching click event.
          if (document.createEvent) {
            const e = document.createEvent('MouseEvents');
            e.initEvent('click', true, true);
            link.dispatchEvent(e);
          }
        }
      }
    });
  }

  // Extra Utility Function Ends

  getSavedCustomeNdaFiles() {
    this._rfqService.GetCustomNDAToRFQ(this.irfqViewModel.rfqId).subscribe(
      (res) => {
        if (res.result === true) {
          if (res.ndaFile && (res.ndaFile !== '' || res.ndaFile.length > 0)) {
            this.isStandardNda = false;
            this.customNDAFile = res.ndaFile;
          }
        }
      },
      error => {
        this._rfqService.handleError(error);
      },
      () => { }
    );
  }

  downloadAllFiles(fileCompArray: string[], partfile, partId, rfqId, isFileDownloaded) {
    if (isFileDownloaded === 'isFileDownloaded') {
      ++this.isFileDownloaded;
    }
    if (isFileDownloaded === 'isFileDownloaded1') {
      ++this.isFileDownloaded1;
    }
    if (isFileDownloaded === 'isFileDownloaded2') {
      ++this.isFileDownloaded2;
    }
    this.Downloadallfiles = {
      filename: [],
      rfQ_Id: 0,
      part_id: 0

    };
    this.temp = [];
    let data = JSON.stringify(fileCompArray);
    this.temp = JSON.parse(data);
    if (partfile !== '') {
      this.temp.push(partfile);
    }
    this.Downloadallfiles.filename = this.temp;
    this.Downloadallfiles.part_id = partId;
    this.Downloadallfiles.rfQ_Id = rfqId;

    this._rfqService.getDownloadAllFileURL(this.Downloadallfiles).subscribe(response => {
      if (response.result === true) {
        const resData = response.data;
        const filelink = resData.privateFileFileName;
        this.logRFQFileClick(this.Downloadallfiles,"downloadAllFiles")
        if (filelink) {
          if (/(iP)/g.test(navigator.userAgent)) {
            window.open(filelink, '_blank');
          }
          // If in Chrome or Safari - download via virtual link click
          const link = document.createElement('a');
          link.href = filelink;

          link.setAttribute('target', '_blank');
          // Dispatching click event.
          if (document.createEvent) {
            const e = document.createEvent('MouseEvents');
            e.initEvent('click', true, true);
            link.dispatchEvent(e);
          }
        }

        if (isFileDownloaded === 'isFileDownloaded') {
          --this.isFileDownloaded;
        }

        if (isFileDownloaded === 'isFileDownloaded1') {
          --this.isFileDownloaded1;
        }

        if (isFileDownloaded === 'isFileDownloaded2') {
          --this.isFileDownloaded2;
        }

      } else {
        if (isFileDownloaded === 'isFileDownloaded') {
          --this.isFileDownloaded;
        }

        if (isFileDownloaded === 'isFileDownloaded1') {
          --this.isFileDownloaded1;
        }

        if (isFileDownloaded === 'isFileDownloaded2') {
          --this.isFileDownloaded2;
        }

      }
    }, error => {
      if (isFileDownloaded === 'isFileDownloaded') {
        --this.isFileDownloaded;
      }

      if (isFileDownloaded === 'isFileDownloaded1') {
        --this.isFileDownloaded1;
      }

      if (isFileDownloaded === 'isFileDownloaded2') {
        --this.isFileDownloaded2;
      }

    })
  }

  isPremium() {
    let IsPremiumEncrypt = AppStorageUtil.getItem('IsPremium');
    let IsPremiumDecrypt = this._profileService.decrypt(IsPremiumEncrypt);
    if (IsPremiumDecrypt !== 'true' && IsPremiumDecrypt !== 'false') {
      AppStorageUtil.clear();
      AppStorageUtil.clearSession();
      this.router.navigate(['auth/login/simple']);
      return;
    }
    if (IsPremiumDecrypt === 'true') {
      return true;
    } else {
      return false;
    }
  }

  goToRfqDdetails(id) {
   /*  AppStorageUtil.setItem('suppCurrentRfqName', this.irfqViewModel.rfqName);
    AppStorageUtil.setItem('suppCurrentRfqDate', this.irfqViewModel.rfqCreatedOn);
    this._rfqService.set(this.selectedRFQ.isRfqLike, 'isRfqLike');
    this._rfqService.set(this.selectedRFQ.isRfqDisLike, 'isRfqDisLike');
    AppStorageUtil.setItem('suppCurrentRfqStatusId', '3');  */
    const encryptedRfqID = this._profileService.encrypt(id);
    window.open("#/supplier/supplierRfqDetails?rfqId="+encryptedRfqID, '_blank');
  //  this.router.navigate(['/supplier/supplierRfqDetails'], { queryParams: { rfqId: encryptedRfqID } });
  }

  showHideRFQPartDetails(event, id, index) {
    event.stopPropagation();
    this.iReviewPartsViewModelColl[index].result = !this.iReviewPartsViewModelColl[index].result;
  }
  setRfdId(setRfqId){
    AppStorageUtil.setItem('rfqid', setRfqId);
  }
  hasRfqAccess(){
    if(this.accountType == appConstants.AccountType.Gold || this.accountType == appConstants.AccountType.Platinum){
      if(this.isPremium() && this.irfqViewModel.isStripeSupplier && this.irfqViewModel.isAllowQuoting){
        return true;
      }
      return false;
    }
    if(this.accountType == appConstants.AccountType.Starter || this.accountType == appConstants.AccountType.GrowthPackage|| this.accountType == appConstants.AccountType.Basic){
      if(this.irfqViewModel.rfqAccess == true){
        return true;
      }
    }
    return false;
  }
  formatPartDimensions(part: any): string {
    if (!part) return 'N/A';
 
    const unit = part.partSizeUnitId === 9 ? '"' : ' mm';
 
    // Prismatic (geometryId 58): L x W x H
    if (part.geometryId === 58) {
      const l = this.formatNumberWithCommas(part.length ?? '');
      const w = this.formatNumberWithCommas(part.width ?? '');
      const h = this.formatNumberWithCommas(part.height ?? '');
      if (l && w && h) return `${l}${unit} x ${w}${unit} x ${h}${unit}`;
      if (l && w) return `${l}${unit} x ${w}${unit}`;
      if (l) return `${l}${unit}`;
      return 'N/A';
    }
 
    // Cylindrical (geometryId 59): L x D OD
    if (part.geometryId === 59) {
      const l = this.formatNumberWithCommas(part.length ?? '');
      const d = this.formatNumberWithCommas(part.diameter ?? '');
      if (l && d) return `${l}${unit} x ${d}${unit} OD`;
      if (l) return `${l}${unit}`;
      if (d) return `${d}${unit} OD`;
      return 'N/A';
    }
 
    // Fallback: show nothing
    return 'N/A';
  }
  formatNumberWithCommas(value: number | string): string {
    if (value === null || value === undefined || value === '') return '';
    return Number(value).toLocaleString('en-US');
  }
  downloadIndividualFile(part,isDownload:boolean=true) {
    if(this.isFileDownloadable(part)) {
      this.downloadS3File(part.rfqPartFile, isDownload, part.rfqId);
    }
  }
  isFileDownloadable(part) {
    if ((this.isNDAaccepted && this.isProfessionalPackage) ||
      (
        this.isPremium() &&
        this.isNDAaccepted &&
        ((this.irfqViewModel?.isStripeSupplier &&
          part?.isAllowPartQuoting) ||
          !this.irfqViewModel?.isStripeSupplier))) {
      return true;
    }
    if (!this.isPremium() ||
      !this.isNDAaccepted ||
      (this.irfqViewModel?.isStripeSupplier &&
        !part?.isAllowPartQuoting)) {
      return false
    }
    return false;
  }
  logRFQFileClick(fileData: any,fileMode: string) {
    const requestData = {
      rfqId: fileData.rfQ_Id,
      companyId: this.loggedCompanyId,
      contactId: this.loggedId,
      fileName: fileMode === 'downloadAllFiles' ? '' : fileData.filename,
     
    };
    // Validate required data
    if (!requestData.rfqId || !requestData.companyId || !requestData.contactId) {
      console.error("Missing required data for RFQ file click logging:", requestData);
      return;
    }
  
    this._profileService.logRfqFileClick(requestData).subscribe({
      next: (response) => {
        console.log("RFQ file click logged successfully:", response);
      },
      error: (error) => {
        console.error("Error logging RFQ file click:", error);
      }
    });
  }
}
